import Layout from '../../components/ui/Layout';
import { ProfileNav } from './PersonalDetails';
import { IconShieldCheck } from '@tabler/icons-react';

export default function Security() {
  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <ProfileNav active="Security" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Security</h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>Manage your password and two-factor authentication</p>

          <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '20px 24px', marginBottom: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 16 }}>Change password</div>
            {['Current password', 'New password', 'Confirm new password'].map(label => (
              <div key={label} style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 6 }}>{label}</label>
                <input type="password" placeholder="••••••••••••" style={{ width: '100%', boxSizing: 'border-box' }} />
              </div>
            ))}
            <button style={{ background: 'var(--color-brand)', color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', padding: '9px 20px', fontSize: 13, cursor: 'pointer' }}>Update password</button>
          </div>

          <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '20px 24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <div style={{ fontSize: 14, fontWeight: 400 }}>Two-factor authentication</div>
              <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: 'var(--color-danger-light)', color: 'var(--color-danger)' }}>Not enabled</span>
            </div>
            <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 16, lineHeight: 1.6 }}>Add an extra layer of security to your account. Choose between Microsoft Authenticator (recommended for Microsoft 365 users) or any TOTP app.</p>
            <div style={{ display: 'flex', gap: 10 }}>
              {[
                { label: 'Microsoft Authenticator', colour: '#0078D4' },
                { label: 'Authenticator app (TOTP)', colour: 'var(--color-brand)' },
              ].map(opt => (
                <button key={opt.label} style={{ background: opt.colour, color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', padding: '9px 16px', fontSize: 12, cursor: 'pointer' }}>
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
